import { imageStatuses } from '../../../const/imageStatuses';



const makeAttachResponseMessages = (isSuccess, imageStatus) => {
  const isReadyForRelease = imageStatus === imageStatuses.ready_for_release;

  if (isSuccess) {
    return isReadyForRelease ? 'ui-general-detach-success' : 'ui-general-attach-success';
  }
  return isReadyForRelease ? 'ui-general-detach-failed' : 'ui-general-attach-failed';
};

export default makeAttachResponseMessages;
